import { matchRouteName, pageState } from '@helpers/page-state';
import axios from 'axios';
import _ from 'lodash';

function trackPropertyChanges(before, after) {
    const changes = {
        moved: [], // { property, fromListId, toListId }
        removed: [], // { property, fromListId }
    };

    // Flatten and map by ID for fast lookup
    const beforeMap = _(before)
        .flatMap((list) => list.items.map((p) => ({ ...p, fromListId: list.id })))
        .keyBy('id')
        .value();

    const afterMap = _(after)
        .flatMap((list) => list.items.map((p) => ({ ...p, toListId: list.id })))
        .keyBy('id')
        .value();

    const allIds = _.union(_.keys(beforeMap), _.keys(afterMap));

    allIds.forEach((id) => {
        const beforeProp = beforeMap[id];
        const afterProp = afterMap[id];

        if (beforeProp && afterProp) {
            // Exists in both → check for move
            if (beforeProp.fromListId !== afterProp.toListId) {
                changes.moved.push({
                    property: afterProp,
                    fromListId: beforeProp.fromListId,
                    toListId: afterProp.toListId,
                });
            }
        } else if (beforeProp && !afterProp) {
            // Was removed
            changes.removed.push({
                property: beforeProp,
                fromListId: beforeProp.fromListId,
            });
        }
    });

    return changes;
}

const state = matchRouteName('land-locator') && {
    lists: pageState.lists,
};

const getters = {
};

const mutations = {
    setLists(state, payload) {
        state.lists = payload;
    },
};

const actions = {
    refreshLists({ commit }) {
        axios.get('/api/land-locator').then((response) => {
            commit('setLists', response.data.data);
        });
    },
    updateLists({ commit }, payload) {
        const difference = trackPropertyChanges(state.lists, payload);
        // commit('setLists', payload); // doesn't trigger reactively
        state.lists = payload;

        if (difference.moved.length > 0 || difference.removed.length > 0) axios.patch('/api/land-locator/lists', difference);

        axios.get('/api/land-locator').then((response) => {
            commit('setLists', response.data.data);
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
